import React from 'react';
import Select from 'react-select';
import {
  userRoundCheckBlue,
  userRoundCheckGreen2,
  userRoundCheckRed,
} from '../../../assets/images/images';
import {customStyles, DropdownIndicator} from '../../../components';
import {useFraudCheck, usePersistFraudData} from '../../../hooks/useFraudCheck';
import {Card, Wrapper} from '../FraudCheckScreens';

export const DetectWithAgeLimit = () => {
  const {setSelectedStatus, selectedStatus, setConfig, config, STATUSES} =
    useFraudCheck({
      limit: 16,
      action: 'pending',
    });

  const statusData = usePersistFraudData({
    config,
    selectedStatus,
    actionKey: 'action',
    COLLECTION: STATUSES,
  });

  return (
    <Wrapper>
      <Card
        extension={
          <div className="flex flex-col gap-1">
            <p className="text-grey font-medium">Age limit</p>
            <p className="text-body text-sm gap-1">
              If the age picked from the response is less than the age limit set
              or doesn’t match the response
            </p>
          </div>
        }
        src={userRoundCheckBlue}
      />
      <Card
        extension={<p className="text-grey font-medium">Age limit</p>}
        src={userRoundCheckGreen2}
      >
        <div className="text-start w-full">
          <label htmlFor="age_limit" className="relative">
            Set age limit
            <input
              type="number"
              id="age_limit"
              name="age_limit"
              className="mt-2"
              value={(config && config?.limit?.toString()) || ''}
              onChange={event => {
                const value = event.target.value;
                setConfig({...config, limit: +value});
              }}
            />
          </label>
        </div>
      </Card>
      <Card
        extension={
          <p className="text-grey font-medium">
            If the age limit is less or does not match
          </p>
        }
        src={userRoundCheckRed}
      >
        <div className="text-start w-full">
          <label htmlFor="status" className="mb-2 relative">
            Set status to
          </label>
          {statusData !== undefined && (
            <Select
              defaultValue={statusData}
              value={statusData || STATUSES[0]}
              onChange={status => {
                setSelectedStatus(status);
                setConfig({...config, action: status.value});
              }}
              options={STATUSES}
              className="basic-multi-select"
              classNamePrefix="react-select"
              components={{DropdownIndicator}}
              styles={customStyles}
              menuPlacement="auto"
              isSearchable={false}
            />
          )}
        </div>
      </Card>
    </Wrapper>
  );
};
